<!-- Route Form -->
@if (page() && routeForm) {
  <medsurf-design-form-control-form
    [formGroup]="routeForm"
    (onSubmit)="onRouteSubmit()">
    <div class="flex flex-column align-items-start row-gap-2 mb-4">
      <!-- Route -->
      <medsurf-design-form-control-input-route-input-text [title]="page()?.title ?? ''"
        [control]="routeForm.controls.route"
        (valueChange)="onRouteSubmit()"
      (valueReset)="onRouteReset()"></medsurf-design-form-control-input-route-input-text>
      <small>{{ 'medsurf-chapter-main-settings.route_change_warning' | translate }}</small>
    </div>
  </medsurf-design-form-control-form>
}
